import * as S from './styles';
import { InputHelperTextProps } from './types';

const InputHelperText = ({ children }: InputHelperTextProps) => <S.Wrapper>{children}</S.Wrapper>;
export default InputHelperText;
